<template>
    <div >
        <div id="print">

        
        <div class="titles">
             <h2>典当绝当变卖告知书</h2>
            <h3>（当物来源承诺书）</h3>
        </div>
       
        <div class="lr">
             <span class="newText">当户：<span class="cont">{{NewDatas.input_names }}</span></span>  <span class="newText">业务单号：<span class="cont">{{NewDatas.input_pnum}}</span></span>   
        </div>
       
        <div class="tb">
            <span class="newText">为保障双方权益，当户办理典当（绝当）前须知悉如下告知约定：</span>
            <span> </span>
        </div>
        <div class="tb">
             <span class="newText"> 一、办理典当绝当、变卖，我方必须采取（包含不限于）火烧、对当物局部物理剪开破坏，使用检测仪等方式对贵金属当物的真伪、含金成分、成色鉴定。检测后，若您提出中止交易或因物品存疑双方最终不能达成交易，当户不得因物品检测被破损要求恢复原状或索赔，当户不能接受以上检测方式，请勿交付当台检测。
               </span>
        </div>

        <div class="tb">
            <span class="newText">
                二、当户须成年且保证当物来源合法。若隐瞒当物非法来源、利用典当销赃、变现，不得办理典当。若发现当物涉嫌违法犯罪所得，我行向公安部门举报。
            </span>
        </div>

        <div class="tb">
            <span class="newText">
                三、经检测当物无异议（无掺杂），我行按一下结算单支付金额。
            </span>
        </div>

        <div class="tb"> 
            <span class="newText">
                 本人:<span class="cont">{{NewDatas.input_names}}</span>          (是/否同意) 绝当变卖当物、放弃赎回当物。
                如您清楚理解本告知书且保证当物来源合法，请签字确认当物绝当报价结算单。你方签名确认视为同意我行采取以上鉴定方式检测当物。
            </span>
           
        </div>

        <div class="tb tc">
            <span class="newText">当户：<span class="cont">{{NewDatas.input_names}}</span></span> <span class="newText">典当行：<span class="cont">{{ $store.state.name }}</span></span>
        </div>

         <div class="tb tc">
            <span class="newText">身份证号：<span class="cont">{{NewDatas.input_idcards}}</span> </span>
        </div>

         <div class="tb tc">
            <span class="newText">电话：<span class="cont">{{NewDatas.input_tels}}</span> </span>
        </div>

        <div class="titles">
        <h3>当物绝当变卖（入/出库）结算单</h3>
        <table style="width:100%">
            <tr height="40px">
                <td width="14.2%">序号</td>
                <td width="14.2%">品名</td>
                <td width="14.2%">重量/g</td>
                <td width="14.2%">成色/%</td>
                <td width="14.2%">过火融化</td>
                <td width="14.2%">单价 元/克</td>
                <td width="14.2%">金额 /元</td>
            </tr>
            <tr>
                <td>1</td>
                <td>{{NewDatas.tabs_inputs}}</td>
                <td>{{NewDatas.tabs_ins}}</td>
                <td><input type="text" v-model="chenS" class="ipt"></td>
                <td><input type="text" v-model="guoH" class="ipt"></td>
                <td>{{(Number(NewDatas.tabs_is) / Number(NewDatas.tabs_ins)).toFixed(2)}}</td>
                <td>{{NewDatas.tabs_is}}</td>
            </tr>
             <tr>
                <td>2</td>
                <td>{{NewDatas.tabs_inputsa}}</td>
                <td>{{NewDatas.tabs_insa || ''}}</td>
                <td><input type="text" v-model="chenSa" class="ipt"></td>
                <td><input type="text" v-model="guoHa" class="ipt"></td>
                <td>{{NewDatas.tabs_isa !==''? (Number(NewDatas.tabs_isa) / Number(NewDatas.tabs_ins)).toFixed(2) : ''}}</td>
                <td>{{NewDatas.tabs_isa}}</td>
            </tr>
             <tr>
                <td>3</td>
                <td>{{NewDatas.tabs_inputsaa}}</td>
                <td>{{NewDatas.tabs_insaa}}</td>
                <td><input type="text" v-model="chenSaa" class="ipt"></td>
                <td><input type="text" v-model="guoHaa" class="ipt"></td>
                <td>{{NewDatas.tabs_isaa !==''?(Number(NewDatas.tabs_isaa) / Number(NewDatas.tabs_insaa)).toFixed(2):'' }}</td>
                <td>{{NewDatas.tabs_isaa}}</td>
            </tr>
            <tr>
                <td colspan="2">合计</td>
                <td>{{NewDatas.tabs_ins !== undefined?(Number(NewDatas.tabs_ins) + Number(NewDatas.tabs_insa) + Number(NewDatas.tabs_insaa)).toFixed(2) : 0}}</td>
                <td colspan="3"></td>
                <td>{{Number(NewDatas.tabs_is)+Number(NewDatas.tabs_isa)+Number(NewDatas.tabs_isaa)}}</td>
                
            </tr>
        </table>

        <div class="tb">
            <span class="newText">温馨提示：上述绝当物报价以本公司的贵金属实时估值报价为准。</span>
        </div>

        <div class="lr">
            <span>复核：</span>
            <span>经办：</span>
            <span>当户签名：</span>
        </div>

         <div class="lr">
            <span>饰台：  </span>
            <span>财务：</span>
            <span>抛售：</span>
        </div>


        </div>
   </div>

 <el-button type="primary" v-print="'#print'">确定打票</el-button>

    </div>
</template>
<script>
export default {
    name:'PrintDiglog',
    props:['NewDatas'],
    data() {
        return {
            title:'',
            chenS:'',
             chenSa:'',
              chenSaa:'',
            guoH:'',
            guoHa:'',
            guoHaa:''
        }
    },
    created() {
      
    },
    mounted() {
       
    },
}
</script>
<style scoped>
.contents{
    /* text-align: center; */
    /* display: flex;
    flex-direction: row;
    justify-content: center; */
    width: 100%;
}
.titles{
    text-align: center;
}
.newText{
    font-size: 16px;
    margin: 10px 0;
}
.lr{
    display: flex;
    flex-direction: row;
    justify-content:space-around
}
.cont{
    text-decoration:underline
}
.tb{
    margin: 10px 0;
}
.tc{
    display: flex;
    flex-direction: row;
    justify-content:space-between
}
table
{
    border-collapse:collapse;
    
}
table,th, td
{
    border: 1px solid black;
}
.ipt{
    border: none;
    height: 100%;
}
</style>